<template>
	<div ref="myElement" class="container">
		<div class="main_box">
			<div class="block_1">
				<div class="block_1_main">
					<div v-if="newsList.length > 0">
						<div class="list_box">
							<div
								v-for="(value, index) in newsList"
								:key="index"
								class="list_el"
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
								@click="goInfo(value)"
							>
								<div class="tit">{{ value.title }}</div>
								<div class="msg_box">
									<div class="left">
										<img :src="webUrl + value.image" />
									</div>
									<div class="right">
										<div class="txt">{{ value.description }}</div>
										<div class="time">{{ value.fabu_time }}</div>
									</div>
								</div>
							</div>
						</div>
						<div
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							class="page_box"
						>
							<el-pagination
								:small="false"
								background
								layout="prev, pager, next"
								:total="total"
								:page-size="12"
								@current-change="pageChange"
							>
							</el-pagination>
						</div>
					</div>
					<div
						v-if="newsList.length == 0 && !listLoading"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<van-empty image="search" description="暂无数据~" />
					</div>
				</div>
			</div>
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { newsList } from '@/api/public';  //新闻列表
import { UPURL } from '@/util/util';
export default {
	components:{
		//
	},
	data() {
		return {
			isLoading: true,  //界面loading
			newsList: [],
			page: 1,
			total: 0,
			listLoading: true,
			webUrl: UPURL,
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
		//获取新闻列表
		that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
		that.getList();
	},
	watch: {
		//
	},
	methods: {
		//分页点击
		pageChange(val) {
			let that = this;
			that.page = val;
			that.getList(true);
		},
		//获取列表
		getList(type) {
			let that = this;
			that.listLoading = true;
			newsList({
				page: that.page,
				page_size: 12,
				leixing: 1,
				language: sessionStorage.getItem('lang')
			}).then(res => {
				that.newsList = res.data.data;
				that.total = res.data.total;
				that.$toast.clear();
				that.listLoading = false;
				if(type) {
					//滚动到列表顶部
					that.$refs.myElement.scrollIntoView({ behavior: 'smooth' });
				}
			});
		},
		//点击查看详情
		goInfo(value) {
			let that = this;
			let routeData = that.$router.resolve({name: "NewsInfo", params: { newInfoId: value.id + '.html' } });
			// window.open(routeData.href, '_blank');
			window.location.href = routeData.href;
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	.block_1{
		background-color: #f6f6f6;
		.block_1_main{
			width: 1200px;
			margin: 0 auto 0 auto;
			padding-bottom: 50px;
			.list_box{
				.list_el:hover{
					transform: scale(1.02);
					box-shadow: 0px 0px 20px 1px rgba(0,0,0,0.08);
				}
				.list_el{
					display: inline-block;
					width: 47%;
					margin: 20px 1.5% 20px 1.5%;
					padding: 36px 30px;
					background-color: #ffffff;
					border-radius: 8px;
					cursor: pointer;
					.msg_box{
						display: flex;
						padding-top: 20px;
						.right{
							flex: 1;
							position: relative;
							padding-left: 24px;
							.time{
								position: absolute;
								bottom: 0;
								font-size: 16px;
								color: #999999;
							}
							.txt{
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 3;
								-webkit-box-orient: vertical;
								font-size: 16px;
								color: #666666;
							}
						}
						.left{
							width: 200px;
							height: 150px;
							img{
								width: 100%;
								height: 100%;
								object-fit: contain;
							}
						}
					}
					.tit{
						height: 76px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						font-size: 24px;
					}
				}
			}
			.page_box{
				padding-top: 50px;
				text-align: center;
			}
		}
	}
}
</style>
<style scoped>
/*分页*/
>>> .page_box .el-pager li:hover{
	color: #C8000A !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #C8000A !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
	color: #ffffff !important;
}
</style>